import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleResource from "@/store/resource/moduleResource.js";
import VisitPoint from "@/models/VisitPoint";
import Api from "@/helpers/api.js";
import pinMap from "@/assets/images/markers/visit_point.png";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";
import GoogleMap from "@/components/Maps/Maps.vue";
import AssignedSkillList from "@/components/skills/AssignedSkillList.vue";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";
import AssignedTimeWindowList from "@/components/time-window/list/AssignedTimeWindowList.vue";
import AssignedFrequencyList from "@/components/frequency/list/AssignedFrequencyList.vue";
import moduleMap from "@/store/map/moduleMap.js";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin";
import FloatingButtons from "@/views/FloatingButtons.vue";

export const visitPointEditMixin = {
	name: "VisitPointEdit",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		GoogleMap,
		AssignedSkillList,
		AssignedCapacityList,
		AssignedTimeWindowList,
		AssignedFrequencyList,
		FloatingButtons,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			visitPoint: JSON.parse(JSON.stringify(this.data)),
			dataRoleStateTipology: null,
			showGeoAgaing: false,
			departments: [],
			countries: [],
			cities: [],
			showMap: false,
			activePrompt: false,
			dataGeo: {},
			activeTab: 0,
			columnsCapacity: ["name", "description", "action"],
			defaultColumnsCapacity: ["name", "description"],
			hours: 0,
			minutes: 0,
			priority: 0,
			showPromptField: false,
			isUpdate: false,
			indexUpdate: null,
			dangerInput: {
				name: {show: false, text: ""},
				identification: {show: false, text: ""},
				address: {show: false, text: ""},
				city: {show: false, text: ""},
				country: {show: false, text: ""},
				phone: {show: false, text: ""},
				cy: {show: false, text: ""},
				cx: {show: false, text: ""},
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
			skillListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "identifier", "action"],
				defaultColumns: ["id", "name", "description", "identifier"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				navbarOptions: true,
			},
		};
	},
	computed: {
		countriesOptions() {
			return this.generateOptionSelect(this.$store.state.moduleCommon.countries, "country_name", "country_name");
		},
		validateForm() {
			return !this.errors.any();
		},
		statusOptions() {
			if (!this.dataRoleStateTipology) {
				return [];
			}
			const {status} = this.dataRoleStateTipology;
			return status.map((status) => {
				return {label: status.name, value: status.id};
			});
		},
		status_local_sel: {
			get() {
				const found = this.statusOptions.find((status) => status.value === this.visitPoint.status_id);
				return {
					label: found === undefined ? "" : found.label,
					value: found === undefined ? "" : found.value,
				};
			},
			set(obj) {
				this.visitPoint.status_id = obj.value;
			},
		},
		selectedCountry: {
			get() {
				if (this.visitPoint.country !== undefined) this.getDepartments(this.visitPoint.country);
				return {
					label: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
					value: this.visitPoint.country === undefined ? "" : this.visitPoint.country,
				};
			},
			set(obj) {
				this.dpto_local_sel = {};
				this.city_local_sel = {};
				this.visitPoint.country = obj.value;
			},
		},
		dpto_local_sel: {
			get() {
				if (this.visitPoint.department) this.getCities(this.visitPoint.department);
				return {
					label: this.visitPoint.department,
					value: this.visitPoint.department,
				};
			},
			set(obj) {
				this.city_local_sel = {};
				this.visitPoint.department = obj.value;
			},
		},
		city_local_sel: {
			get() {
				return {
					label: this.visitPoint.city,
					value: this.visitPoint.city,
				};
			},
			set(obj) {
				this.visitPoint.city = obj.value;
			},
		},
		propertiesList: {
			get() {
				return this.visitPoint["json_properties"];
			},
			set(obj) {
				this.visitPoint["json_properties"] =
					this.visitPoint["json_properties"] === null ? [] : this.visitPoint["json_properties"];
				this.visitPoint["json_properties"].push(obj);
			},
		},
		propertiesObject: {
			get() {
				return this.visitPoint["additional_info"];
			},
			set(obj) {
				this.visitPoint["additional_info"][obj.label] = obj.value;
			},
		},
		capacityIds() {
			return this.visitPoint["capacities"] && this.visitPoint["capacities"] !== null
				? this.visitPoint["capacities"].map(({capacity_id}) => capacity_id)
				: [];
		},
		skillsIds() {
			return this.visitPoint["skill_id"] && this.visitPoint["skill_id"] !== null
				? this.visitPoint["skill_id"]
				: [];
		},
		timeWindowIds() {
			return this.visitPoint["time_window_id"] && this.visitPoint["time_window_id"] !== null
				? this.visitPoint["time_window_id"]
				: [];
		},
		frequencyIds() {
			return this.visitPoint["repeat_frequency_id"] && this.visitPoint["repeat_frequency_id"] !== null
				? this.visitPoint["repeat_frequency_id"]
				: [];
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoCoder() {
			const {country, city, address, department} = this.visitPoint;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.MissingAddress.Title"),
					text: this.$t("VisitPoints.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.Georeferencer"),
							text: this.$t("VisitPoints.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}

					if (res.status === 200) {
						this.dataGeo = {...res.data};
						this.visitPoint.cy = parseFloat(this.dataGeo.latitude);
						this.visitPoint.cx = parseFloat(this.dataGeo.longitude);
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							Anuket.clearMap();
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPoints.FindAddress.Title"),
								text: this.$t("VisitPoints.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false, "upload", pinMap, true);
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPoints.ErrorFindAddress.Title"),
								text: this.$t("VisitPoints.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		geoInverso({cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					this.dataGeo.longitude = parseFloat(cx);
					this.dataGeo.latitude = parseFloat(cy);
					if (res.data.address1 !== this.visitPoint.address) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPoints.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPoints.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPoints.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		acceptAlert() {
			this.visitPoint.country = this.dataGeo.country_long_name;
			this.visitPoint.address = this.dataGeo.address1;
			this.dpto_local_sel = this.dataGeo.department1;
			this.city_local_sel = this.dataGeo.city1;
			this.visitPoint.department = this.dataGeo.department1;
			this.visitPoint.city = this.dataGeo.city1;
			this.visitPoint.cx = parseFloat(this.dataGeo.longitude.toFixed(8));
			this.visitPoint.cy = parseFloat(this.dataGeo.latitude.toFixed(8));
		},
		close() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.updateVisitPoint();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
					this.activeTab = 0;
				}
			});
		},
		updateVisitPoint() {
			const ids_skill = this.$store.state.moduleSkills.listSelectedSkills.map(({id}) => id);
			const ids_time_window = this.$store.state.moduleTimeWindow.assignedTimeWindows.map(({id}) => id);
			this.visitPoint["capacities"] =
				this.$store.state.moduleCapacity.listSelectedCapacities.map((capacity) => {
					let jobType;
					if (capacity.typeService === "DELIVERY") {
						jobType = "DELIVERY";
					} else if (capacity.typeService === "PICKUP") {
						jobType = "PICKUP";
					} else if (capacity.typeService === this.$t("DELIVERY")) {
						jobType = "DELIVERY";
					} else if (capacity.typeService === this.$t("PICKUP")) {
						jobType = "PICKUP";
					} else {
						jobType = capacity.typeService.value;
					}
					return {
						capacity_id: capacity.id,
						amount: parseInt(capacity.demand),
						job_type: jobType,
					};
				}) || [];
			this.visitPoint["skills_id"] = ids_skill || [];
			this.visitPoint["time_window_id"] = ids_time_window || [];
			this.visitPoint["repeat_frequency_id"] =
				this.$store.state.frequency.assignedFrequencies.map(({id}) => id) || [];
			this.visitPoint["additional_info"] = this.propertiesObject || {};
			this.visitPoint["json_properties"] = this.propertiesList || [];
			this.visitPoint["time_service"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:00`;
			this.visitPoint["priority"] = parseInt(this.visitPoint["priority"]);
			delete this.visitPoint["skill_id"];
			delete this.visitPoint["status_name"];
			delete this.visitPoint["isEditTypeService"];
			delete this.visitPoint["demand"];
			delete this.visitPoint["typeService"];
			delete this.visitPoint["isEditDemand"];
			delete this.visitPoint["isDelivery"];
			delete this.visitPoint["isPickup"];
			delete this.visitPoint["id"];
			this.$store
				.dispatch("moduleVisitPoint/update", {items: this.visitPoint, id: this.$route.params.id})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPoints.EditSuccess.Title"),
						text: this.$t("VisitPoints.EditSuccess.Text"),
					});
					this.visitPoint = new VisitPoint({});
					this.$router.push({name: "app-visit-point-list"});
				})
				.catch((error) => {
					console.warn(error);
					this.validateErrorRegister(error);
				});
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		getCities(departmentName) {
			Api.post("/divipola", {
				country: this.visitPoint.country,
				department: departmentName ? departmentName.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.cities = this.generateOptionSelect(res.data, "city_name", "city_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
				});
		},
		getDepartments(countryName) {
			Api.post("/divipola", {
				country: countryName,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.departments = this.generateOptionSelect(res.data, "department_name", "department_name");
				})
				.catch((e) => {
					console.error("❌ Error Getting Department name", e);
				});
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList = property;
				this.propertiesObject = property;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.propertiesObject[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.propertiesObject[property.label] = property.value;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		fetchDataSelect() {
			const payload = {
				role: [1, 2, 3, 4, 5],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			this.$store
				.dispatch("moduleCommon/fetchDataSelect", payload)
				.then((res) => {
					this.dataRoleStateTipology = res.data;
					setTimeout(() => {
						if (this.$refs.moduleMap)
							this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false, "upload", pinMap, true);
					}, 1000);
				})
				.catch((error) => {
					console.error(error);
				});
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumber(event) {
			if (this.hours.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberPriority(event) {
			if (this.hours.length === 3) {
				event.preventDefault();
				return false;
			}
		},
		validateDateHours() {
			if (this.hours === "" || this.hours === null) this.hours = 0;
		},
		validateDateMinutes() {
			if (this.minutes === "" || this.minutes === null) this.minutes = 0;
		},
		validateDatePriority() {
			if (this.visitPoint.priority === "" || this.visitPoint.priority === null) this.visitPoint.priority = 0;
		},
		async getAssignedSkillsByIds(ids) {
			try {
				this.openLoading();
				await this.$store.dispatch("moduleSkills/findSkillFilter", {
					id: ids,
					fields: ["id", "name", "description", "identifier"],
				});
				this.closeLoading();
			} catch (error) {
				this.closeLoading();
			}
		},
		async getAssignedCapacitiesByIds(ids) {
			try {
				this.openLoading();
				await this.$store.dispatch("moduleCapacity/findCapacityFilter", {
					id: ids,
					fields: ["id", "name", "description"],
					assigned: true,
				});
				this.closeLoading();
			} catch (error) {
				this.closeLoading();
			}
		},
		async getTimeWindowByIds(ids) {
			try {
				this.openLoading();
				await this.$store.dispatch("moduleTimeWindow/timeWindowAssigned", {
					order_by: ["id"],
					sort: "desc",
					id: ids,
				});
				this.closeLoading();
			} catch (error) {
				this.closeLoading();
			}
		},
		async getFrequencyByIds(ids) {
			try {
				this.openLoading();
				await this.$store.dispatch("frequency/frequencyFilter", {
					order_by: ["id"],
					sort: "desc",
					id: ids,
					assign: true,
				});
				this.closeLoading();
			} catch (error) {
				this.closeLoading();
			}
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				setTimeout(() => {
					if (this.visitPoint.cx !== 0 && this.visitPoint.cy !== 0)
						this.$refs.moduleMap.addMarkerVisitPoint(this.visitPoint, false, "upload", pinMap, true);
				}, 1000);
			}
		},
		status_local_sel(object) {
			this.visitPoint.status_id = object.value;
		},
		hours(val) {
			if (val > 23) {
				this.hours = 23;
			}
		},
		minutes(val) {
			if (val > 59) {
				this.minutes = 59;
			}
		},
		"visitPoint.priority"(val) {
			if (val > 100) {
				this.visitPoint.priority = 100;
			}
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store.dispatch("moduleCommon/getCountries").catch((error) => {
				console.error(error);
			});
		}
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
	},
	mounted() {
		this.showMap = true;
		this.fetchDataSelect();
		if (this.skillsIds && this.skillsIds.length > 0) {
			this.getAssignedSkillsByIds(this.skillsIds);
		}
		if (this.capacityIds && this.capacityIds.length > 0) {
			this.getAssignedCapacitiesByIds(this.capacityIds);
		}
		if (this.timeWindowIds && this.timeWindowIds.length > 0) {
			this.getTimeWindowByIds(this.timeWindowIds);
		}
		if (this.frequencyIds && this.frequencyIds.length > 0) {
			this.getFrequencyByIds(this.frequencyIds);
		}
		if (this.visitPoint.hasOwnProperty("time_service") && this.visitPoint["time_service"] !== null) {
			const [hours, minutes] = this.visitPoint["time_service"].split(":");
			this.hours = parseInt(hours);
			this.minutes = parseInt(minutes);
		}
	},
	beforeDestroy() {
		this.showGeoAgaing = false;
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTimeWindow/REMOVE_ALL_ASSIGNED_TIME_WINDOW");
		this.$store.commit("frequency/REMOVE_ALL_ASSIGNED_FREQUENCY");
	},
};
